import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { meridianData } from '../DataSets';

const Meridian = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="meridian"
      name="meridian"
      items={meridianData}
      label="Meridian"
      placeholder="Select meridian"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default Meridian;
